import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import _ from 'lodash';
import React from 'react';

require('highcharts/modules/exporting')(Highcharts);

interface IPieChartComponentProps {
  title: string
  isLoading: boolean
  legend: boolean
  categories: string[]
  factor: string
  seriesName: string
  series: any[]
  chartHeight?: number
  htmlSubtitle?: string
  avannisAvg: string | number
  dataPoints: IPieChartDataPoint[]
  noDataMessage: string
  clickHandler?: any
  highChartsTheme?: any
}

interface IPieChartComponentState {
  trendChartRef: any
  trendGraphOptions: any
}

export interface IPieChartDataPoint {
  color: string
  count: number
  name: string
  selected: boolean
  surveyCount: number
  y: number
}

export class PieChartComponent extends React.Component<IPieChartComponentProps> {
  state: IPieChartComponentState = {
    trendChartRef: null,
    trendGraphOptions: null,
  }
  componentDidMount() {
    this.state.trendChartRef = React.createRef();

    if (this.props.dataPoints.length > 0) {
      this.setPieChartOptions();
    }
  }

  componentDidUpdate(prevProps: IPieChartComponentProps, prevState: IPieChartComponentState) {
    if (prevProps.dataPoints !== this.props.dataPoints) {
      this.setPieChartOptions();
    }
  }

  setPieChartOptions() {
    const { seriesName, title, legend, factor, chartHeight, htmlSubtitle, avannisAvg, categories, dataPoints, noDataMessage, clickHandler } = this.props;
    let height = 300;
    if (chartHeight && chartHeight > 0) {
      height = chartHeight;
    }

    let min = _.min(dataPoints.reduce((acc, curr) => acc.concat(curr.y), []));
    let max = _.max(dataPoints.reduce((acc, curr) => acc.concat(curr.y), []));

    const suffix = factor === '100' ? '%' : '';

    let subtitle = {};
    if (htmlSubtitle) {
      subtitle = {
        useHTML: true,
        text: htmlSubtitle
      };
    }

    let exportingOptions = {};
    let navigationOptions = {};

    if (!categories) {
      exportingOptions = {
        buttons: {
          contextButton: {
            enabled: false
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          enabled: true
        }
      };
    } else {
      exportingOptions = {
        chartOptions: {
          title: {
            style: { display: 'block' },
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true,
                format: '{y:.1f}',
              }
            }
          },
          legend: {
            enabled: true,
            symbolRadius: 0,
          },
          subtitle: {
            useHTML: true,
            text: htmlSubtitle.substring(0, htmlSubtitle.indexOf('<br/>'))
          }
        },
        buttons: {
          contextButton: {
            symbol: 'url(images/bars.png)',
          }
        }
      };
      navigationOptions = {
        buttonOptions: {
          verticalAlign: 'top',
          y: -10
        }
      };
    }

    if (avannisAvg !== 0 && avannisAvg < min) {
      min = avannisAvg;
    }

    if (avannisAvg !== 0 && max < avannisAvg) {
      max = avannisAvg;
    }
    if (max > 90) {
      max = 105;
    }

    const seriesArr = [{
      name: seriesName,
      data: dataPoints,
      color: 'var(--brand-blue)',
      point: {
        events: {
          click(event) {
            if (clickHandler) {
              const obj = event.point;
              clickHandler(obj);
            }
          }
        }
      }

    }];
    // if (clickHandler) {
    //   seriesArr[0].point =
    // }
    this.setState({
      trendGraphOptions: {
        lang: {
          noData: noDataMessage,
          useHTML: true
        },
        chart: {
          type: 'pie',
          height,
        },
        title: {
          useHTML: true,
          text: title,
          x: 0,
          y: 5,
          align: 'left',
          style: { display: (title && title.length > 0) ? 'block' : 'none' },
        },
        subtitle,
        legend: {
          enabled: false,
        },
        xAxis: {
          categories,
        },
        yAxis: {
          title: null,
          labels: {
            enabled: true
          },
          min,
          max,
          maxPadding: .45
        },
        tooltip: {
          formatter() {
            return '<b>' + this.point.name + '</b>: ' + this.point.count + '<br/>Total Statements: ' + this.point.surveyCount + '<br/>Percentage: <b>' + this.point.y.toFixed(1) + '%</b>';
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false,
              format: '{y}',
              style: {
                color: 'black'
              }
            },
            showInLegend: true
          },
        },
        credits: {
          enabled: false
        },
        series: seriesArr,
        exporting: exportingOptions,
        navigation: navigationOptions
      }
    });
  }

  setDataPoints(series: any[]) {
    this.setState({ dataPoints: series });
  }

  render() {
    const { trendGraphOptions, trendChartRef } = this.state;
    const { highChartsTheme } = this.props;
    if (highChartsTheme) {
      Highcharts.setOptions(highChartsTheme);
    }

    return (
      <div>
        <section className="highcharts-component">
          {
            (trendGraphOptions && trendChartRef) &&
            <HighchartsReact
              highcharts={Highcharts}
              options={trendGraphOptions}
              allowChartUpdate={true}
              ref={trendChartRef}
            />
          }
        </section>
      </div>
    );
  }
}
